<template>
  <div class="language-switcher">
    <div
      v-for="(langTitle, code) in $options.availableLanguages"
      :key="code"
      :class="{active: $i18n.locale === code}"
      class="language-switcher__item"
      @click="updateLanguage(code)"
    >
      {{ langTitle }}
    </div>
  </div>
</template>

<script>
import {api} from '@/api/api'

export default {
  name: 'LanguageSwitcher',
  availableLanguages: {
    uk: 'Укр',
    en: 'Eng'
  },
  methods: {
    updateLanguage(code) {
      if(code) {
          this.$router.replace({params: {lang: code}, query: this.$route.query})
          this.$root.$i18n.locale = code
      } else {
        code = this.$root.$i18n.locale
      }
      const formData = new FormData()
      formData.append('interface_language', code)
      api.auth.updateUserInfo(formData)
    }
  }
}
</script>

<style scoped lang="scss">
@import "~@/assets/scss/theme.scss";

.language-switcher {
  display: flex;
  align-items: center;
  column-gap: 30px;

  &__item {
    font-weight: 600;
    font-size: 15px;
    line-height: 18px;
    color: $active-green;
    text-transform: uppercase;
    position: relative;
    user-select: none;
    cursor: pointer;

    &.active {
      &::after {
        content: "";
        position: absolute;
        bottom: -10px;
        left: 0;
        width: 100%;
        height: 2px;
        background-color: $active-green;
        pointer-events: none;
      }
    }
  }
}
</style>
